module.exports = __webpack_public_path__ + "img/helping-over-4500-desktop.18676d88.svg";